<template>
    <div class="sidebar" :class="{ borderDiv: !collapse }">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            :text-color="TextColor"
            background-color="#001529"
            unique-opened
            router
            active-text-color="#66CCFF"
        >
              <template v-for="item in menus" >
                <template v-if="item.children">
                    <el-submenu :index="item.url" :key="item.url">
                        <template slot="title">
                            <!-- <i :class="item.icon"></i> -->
                            <svg-icon :iconClass="item.iconClass == null ? '' : item.iconClass" />&nbsp;&nbsp;
                            <span slot="title">{{ item.name }}</span>
                        </template>
                        <template v-for="subItem in item.children">
                            <el-submenu v-if="subItem.children" :index="subItem.url" :key="subItem.url">
                                <template slot="title">{{ subItem.name }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.children" :key="i" :index="threeItem.url">{{
                                    threeItem.name
                                }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.url" :key="subItem.url">
                                <template slot="title">
                                    <!-- <i :class="subItem.icon"></i> -->
                                    <svg-icon :iconClass="subItem.iconClass == null ? '' : subItem.iconClass" />
                                    &nbsp;&nbsp;
                                    <span slot="title">{{ subItem.name }}</span>
                                </template>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.url" :key="item.url">
                        <!-- <i :class="item.icon"></i> -->
                        <svg-icon :iconClass="item.iconClass == null ? '' : item.iconClass" />&nbsp;&nbsp;
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
export default {
    data() {
       var that=this
        return {
            collapse: false,
            TextColor: '#FFFFFF',
            BackColor: '#19202D',
            loginName:sessionStorage.getItem('loginName'),
            items: [
                {
                    url: '/BusManage-Detail',
                    name: '商家管理'
                },
                {
                    url: '/DisplayManage',
                    name: '显示管理'
                },
                {
                    url: '/OrderBusManage',
                    name: '订单管理'
                },
                {
                    url: '/ContentManage',
                    name: '内容管理'
                },
                {
                    url: '/Home',
                    name: '用户管理'
                },
                {
                    url: '/EnterManage',
                    name: '入驻管理'
                },
                {
                    url: '/StatManage',
                    name: '统计管理'
                },
                {
                    url: '/InfoManage',
                    name: '信息管理',
                    children: [
                        {
                            url: '/InfoManage-Limit',
                            name: '限号信息'
                        },
                        {
                            url: '/InfoManage-News',
                            name: '联系我们'
                        }
                    ]
                }
               
            ],
            menus: [
                {
                    url: '/ClothManage',
                    name: '服饰管理'
                },
                {
                    url: '/ClothStock',
                    name: '库存管理'
                },
                {
                    url: '/UserManage',
                    name: '用户管理'
                },
                {
                    url: '/ClothConfig',
                    name: '服饰配置'
                },
                {
                    url: '/ClothSchool',
                    name: '校服配置'
                },
                {
                    url: '/SystemConfig',
                    name: '系统配置'
                }
                
               
            ]
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
      this.loginName=sessionStorage.getItem('loginName')
    },
    methods: {}
};
</script>

<style scoped>
.borderDiv {
    border-right: solid 1px #e6e6e6;
}

.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    /* height: 100%; */
    height: calc(100% - 70px);
    width: 200px;
    bottom: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
}

.sidebar > ul {
    height: 100%;
}

.iconfont {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
}
.el-menu-item,
.el-submenu__title {
    background-color: rgba(225, 225, 225, 0.1);
}
</style>
